// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"28f9d0f8","76":"767ecc04","95":"326d38e9","188":"12141e93","488":"044e9024","496":"2bff620b","552":"4dbff0d9","672":"9f299b59","835":"a0a57d18","914":"882de135"}[chunkId] + ".chunk.js";
};